import { useState } from "react";
import axios from "axios";
import { Card, CardContent, Typography, TextField, Button } from "@mui/material";
import { Box } from "@mui/system";
import { useNavigate } from "react-router-dom";
import { API_BASE } from "./utils/apiBase";

function ChangePassword({ user, onPasswordChanged }) {
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [error, setError] = useState("");
  const [submitting, setSubmitting] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    if (!newPassword || !confirmPassword) {
      setError("Both password fields are required.");
      return;
    }
    if (newPassword !== confirmPassword) {
      setError("Passwords do not match.");
      return;
    }
    setSubmitting(true);
    try {
      await axios.post(
        API_BASE + "/api/change-password",
        { newPassword, confirmPassword },
        { withCredentials: true }
      );
      if (typeof onPasswordChanged === "function") {
        await onPasswordChanged();
      } else {
        const { data } = await axios.get(API_BASE + "/api/me", { withCredentials: true });
        const role = (data?.user?.role || user?.role || "").toLowerCase();
        if (role === "hr") navigate("/dashboard/hr");
        if (role === "employee") navigate("/dashboard/employee");
        if (role === "custodian") navigate("/dashboard/custodian");
      }
    } catch (err) {
      setError(err?.response?.data?.error || "Password change failed");
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <Box
      sx={{
        height: "100vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        bgcolor: "#f3f4f6",
        fontFamily: "Roboto, sans-serif",
        px: 2,
      }}
    >
      <Card sx={{ width: "100%", maxWidth: 380, borderRadius: 4, boxShadow: 4 }}>
        <CardContent>
          <Typography variant="h5" fontWeight={500} align="center" mb={2}>
            Change Password
          </Typography>
          {error && (
            <Typography color="error" variant="body2" align="center" mb={1}>
              {error}
            </Typography>
          )}
          <Box component="form" onSubmit={handleSubmit}>
            <TextField
              label="New Password"
              type="password"
              fullWidth
              margin="normal"
              value={newPassword}
              onChange={(e) => setNewPassword(e.target.value)}
              required
              inputProps={{ autoComplete: "new-password" }}
            />
            <TextField
              label="Confirm Password"
              type="password"
              fullWidth
              margin="normal"
              value={confirmPassword}
              onChange={(e) => setConfirmPassword(e.target.value)}
              required
              error={Boolean(confirmPassword) && newPassword !== confirmPassword}
              helperText={
                confirmPassword && newPassword !== confirmPassword ? "Passwords do not match." : " "
              }
              inputProps={{ autoComplete: "new-password" }}
            />
            <Button
              type="submit"
              fullWidth
              variant="contained"
              sx={{
                mt: 2,
                borderRadius: 3,
                py: 1.2,
                backgroundColor: "#2563eb",
                textTransform: "none",
                fontSize: "1rem",
                "&:hover": { backgroundColor: "#1e40af" },
              }}
              disabled={submitting}
            >
              {submitting ? "Saving..." : "Save Password"}
            </Button>
          </Box>
        </CardContent>
      </Card>
    </Box>
  );
}

export default ChangePassword;
